module.exports = __webpack_public_path__ + "static/img/matanza-digital-1.e403106.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/matanza-digital-1.jpg
// module id = Dh+B
// module chunks = 1